// extracted by mini-css-extract-plugin
export default {"xmButton":"xmButton__jcCcg","primary":"primary__x7KJZ","disabled":"disabled__JPGH5","secondary":"secondary__xfV02","fullWidth":"fullWidth__SF1I5","ml8":"ml8__mvfZf"};